module.exports = __webpack_public_path__ + "static/media/solo-nationals.b866ef0e.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/solo-nationals.png
// module id = 1165
// module chunks = 0